module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 86
// module chunks = 75